export function forceResize() {
  window.dispatchEvent(new Event('resize'))
}
